"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));

var withStyles_1 = __importDefault(require("@material-ui/core/styles/withStyles"));

var Table_1 = __importDefault(require("@material-ui/core/Table"));

var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));

var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));

var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));

var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));

var BB8Button_1 = __importDefault(require("./BB8Button"));

require("./BB8AlertTable.scss");

var BB8SimpleTable_1 = __importDefault(require("./BB8SimpleTable"));

var issueIdentifier = "error";
var alertCount = "alertCount";
var CustomTableCell = withStyles_1.default(function (theme) {
  return createStyles_1.default({
    body: {
      backgroundColor: "rgb(254, 250, 244)",
      color: "#231F20",
      fontFamily: "Omnes",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 4,
      opacity: 0.9
    },
    head: {
      alignSelf: "flex-start",
      backgroundColor: "#F2F5F7",
      borderBottomColor: "#CCD9E0",
      borderBottomWidth: 2,
      color: theme.palette.common.black,
      fontWeight: "bold",
      lineHeight: 2,
      position: "sticky",
      top: 0,
      zIndex: 10
    }
  });
})(TableCell_1.default);

var styles = function styles(theme) {
  return {
    noDataRow: {
      alignItems: "center",
      backgroundColor: theme.palette.status.warning,
      display: "flex"
    },
    root: {
      marginTop: theme.spacing.unit * 3,
      overflowX: "auto",
      width: "100%"
    },
    row: {
      "&:nth-of-type(odd)": {
        backgroundColor: "#F2F5F7"
      },
      borderColor: "#DE7426",
      borderLeftStyle: "solid",
      borderLeftWidth: 4
    },
    table: {
      minWidth: 700
    }
  };
};

var BB8AlertTable =
/** @class */
function (_super) {
  __extends(BB8AlertTable, _super);

  function BB8AlertTable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      expand: []
    };

    _this.toggleRow = function (i, row) {
      _this.setState(function (currentState) {
        var _a;

        return {
          expand: __assign({}, currentState.expand, (_a = {}, _a[i] = !currentState.expand[i], _a))
        };
      });

      if (_this.props.onExpand) {
        _this.props.onExpand(row);
      }
    };

    return _this;
  }

  BB8AlertTable.prototype.render = function () {
    var _this = this;

    return react_1.default.createElement(Table_1.default, {
      id: this.props.id
    }, !this.props.isEmpty && react_1.default.createElement(TableHead_1.default, null, react_1.default.createElement(TableRow_1.default, null, !this.props.isEmpty && this.props.cols.map(function (_a, index) {
      var title = _a.title;
      return react_1.default.createElement(CustomTableCell, {
        key: index
      }, title);
    }))), react_1.default.createElement(TableBody_1.default, null, this.props.isEmpty && react_1.default.createElement(TableRow_1.default, null, react_1.default.createElement(CustomTableCell, {
      className: this.props.classes.noDataRow + " no-data-row",
      colSpan: this.props.cols.length
    }, react_1.default.createElement("div", {
      className: "no-data-row-icon"
    }), react_1.default.createElement("div", {
      className: "no-data-row-message"
    }, "No unresolved file failures"))), this.props.data.map(function (row, i) {
      return react_1.default.createElement(react_1.default.Fragment, {
        key: i
      }, react_1.default.createElement(TableRow_1.default, {
        hover: true,
        key: i,
        className: _this.props.classes.row
      }, _this.props.cols.map(function (_a) {
        var id = _a.id;
        return react_1.default.createElement(CustomTableCell, {
          key: "cell-" + id + "-" + i
        }, id !== "issues" ? row[id] : row[issueIdentifier].data && react_1.default.createElement(BB8Button_1.default, {
          variant: "text",
          // tslint:disable-next-line:jsx-no-lambda
          onClick: function onClick() {
            return _this.toggleRow(i, row);
          }
        }, row[alertCount], react_1.default.createElement("img", {
          src: require("../assets/images/bb8-expand_more-24px.svg"),
          style: _this.state.expand[i] ? {
            transform: "rotate(180deg)"
          } : undefined
        })));
      })), _this.state.expand[i] && react_1.default.createElement(TableRow_1.default, {
        hover: true,
        key: "row-" + i
      }, react_1.default.createElement(TableCell_1.default, null), react_1.default.createElement(TableCell_1.default, {
        colSpan: 6
      }, row[issueIdentifier].data ? react_1.default.createElement(BB8SimpleTable_1.default, {
        key: "sub-table-" + i,
        cols: row[issueIdentifier].cols,
        data: row[issueIdentifier].data
      }) : null)));
    })));
  };

  return BB8AlertTable;
}(react_1.default.Component);

exports.default = withStyles_1.default(styles)(BB8AlertTable);